var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "photoIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.953,
    height: 20.953,
    viewBox: "0 0 20.953 20.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M18.988,0H1.964A1.964,1.964,0,0,0,0,1.964V18.988a1.964,1.964,0,0,0,1.964,1.964H18.988a1.964,1.964,0,0,0,1.964-1.964V1.964A1.964,1.964,0,0,0,18.988,0Zm.655,12.827-2.809-2.809a.655.655,0,0,0-.923,0l-3.47,3.464L8.322,9.363a.655.655,0,0,0-.923,0L1.31,15.446V1.964a.655.655,0,0,1,.655-.655H18.988a.655.655,0,0,1,.655.655Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M226.619,80a2.619,2.619,0,1,0,2.619,2.619A2.619,2.619,0,0,0,226.619,80Zm0,3.929a1.31,1.31,0,1,1,1.31-1.31A1.31,1.31,0,0,1,226.619,83.929Z",
    transform: "translate(-214.833 -76.726)",
    fill: "#3e3e3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photoIcon.bf1a26e7405e7b176621a1ad80362314.svg";
export { ForwardRef as ReactComponent };